import styled from 'styled-components'

import theme from 'theme_'

export const HomeSystemStatesContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HomeSystemStatesTitle = styled.div`
  font-weight: 900;
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 16px;
`

export const HomeSystemStatesSearchWrapper = styled.div`
  margin-bottom: 16px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`

export const HomeSystemStatesInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96px;
  color: ${theme.colors.darkeyGrey};
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`
